import { createContext, useContext, useEffect, useState } from "react";
import { combineAndDecryptPrivateKey, decryptString } from "../utils/security";

interface SecurityContextType {
  publicKey: string | null;
  privateKey: string | null;
  isInitialized: boolean;
}

const SecurityContext = createContext<SecurityContextType>({
  publicKey: null,
  privateKey: null,
  isInitialized: false,
});

export const SecurityProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [publicKey, setPublicKey] = useState<string | null>(null);
  const [privateKey, setPrivateKey] = useState<string | null>(null);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    try {
      const savedPublicKey = sessionStorage.getItem("c");
      const savedValue0 = sessionStorage.getItem("a");
      const savedValue1 = sessionStorage.getItem("b");

      setPublicKey(savedPublicKey || null);

      if (savedValue0 && savedValue1) {
        const decryptedValue = combineAndDecryptPrivateKey([
          decryptString(savedValue0),
          decryptString(savedValue1),
        ]);
        setPrivateKey(decryptedValue || null);
      }

      setIsInitialized(true);
    } catch (error) {
      console.error("Security initialization failed:", error);
      setPrivateKey(null);
      setIsInitialized(true);
    }
  }, []);

  return (
    <SecurityContext.Provider value={{ publicKey, privateKey, isInitialized }}>
      {children}
    </SecurityContext.Provider>
  );
};

export const useSecurity = () => {
  const context = useContext(SecurityContext);
  if (!context) {
    throw new Error("useSecurity must be used within a SecurityProvider");
  }
  return context;
};
